import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seobanner from "../Page-section/Seo/Seobanner";
import Seoprocess from "../Page-section/Seo/Seoprocess";
// import Seoservice from "../Page-section/Seo/Seoservice";
import { useSEO } from "../hooks/useSEO";

function Seo() {
  useSEO({
    title: "SEO Agency in Noida | Get More Traffic, Leads & Sales",
    description:
      "Get top rankings, more traffic, and quality leads with our expert SEO Agency in Noida. Proven strategies, affordable plans, and free consultation to grow your business online.",
    canonical: "https://empowerweb.in/seo-agency-noida",
    ogTitle: "seo agency in Noida, best seo company in noida",
    ogDescription:
      "Boost your online visibility with proven SEO strategies. Get expert SEO services in Noida and Delhi NCR for sustainable growth.",
    keywords:
      "seo agency in Noida, search engine optimization company in Noida,best seo company in noida, seo expert in Noida, SEO Company in Noida",
  });
  return (
    <div>
      <div>
        <Header />
        <Navbar />
        <main>
          <Seobanner />
          <Seoprocess />
          {/* <Seoservice /> */}
        </main>
        <Footer />
      </div>
    
    </div>
  );
}

export default Seo;
